export const navBarTeacher = (orgStructure) => [
  {
    name: "Hem",
    url: "/",
    icon: "home",
  },
  {
    title: true,
    name:
      localStorage.getItem("schoolName") === null
        ? "Min skola"
        : localStorage.getItem("schoolName"),
    url: "/",
  },
  {
    isProgramsAndClasses: true,
    programsAndClasses: [...orgStructure],
  },
];

export default navBarTeacher;
